/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-const-assign */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import {  getFooterASG } from "../api/about/abouthook";
import { getDrupalImageUrl } from '../api/about/aboutapi';
interface DrupalResponse {
  data: any;
  included?: any[];
}
const FooterSubONew: React.FC = () => {

 const [data, setData] = useState<DrupalResponse | null>(null);
   localStorage.removeItem('appurl');
    localStorage.removeItem('appimg');
    localStorage.removeItem('googleurl');
    localStorage.removeItem('googleimg');
    localStorage.removeItem('grooneappcontent');
    const [loading, setLoading] = useState(true);
      let [imageUrl, setImageUrl] = useState('');
        let [GooglePlayurl, setImageUrl1] = useState('');
        let [AppStoreurl, setImageUrl2] = useState('');
   useEffect(() => {
       const fetchAll = async () => {
         try {
           const [ heroData ] = await Promise.all([ getFooterASG() ]);
           setData(heroData);
         } catch (err) {
           console.error(err);
         } finally {
           setLoading(false);
         }
       };
       fetchAll();
     }, []);
   
     const node = data?.data ?? {};
     // console.log(node);
       /** Collect included images */
       const included = data?.included || [];
     
       // 📌 Featured image URL
       const featuredId = node?.relationships?.field_featured_image?.data?.id;
      // console.log(featuredId);
       const featuredUrl = getDrupalImageUrl(featuredId, included);
     
       // 📌 Gallery Images
       const galleryIds = node?.relationships?.field_gallery_images?.data || [];
       const galleryUrls = galleryIds
         .map((g: any) => getDrupalImageUrl(g.id, included))
         .filter(Boolean);
    //  if (loading) return <div>Loading...</div>;
   
      imageUrl= featuredUrl ? featuredUrl : "" ;

    const divStyle = {
      backgroundImage: imageUrl ? `url(${imageUrl})` : 'none',
      backgroundSize: 'cover'
    };
   
    localStorage.setItem('appurl', node?.attributes?.field_link_url?.[1].uri || "");
    localStorage.setItem('appimg', galleryUrls?.[0] || "");

    localStorage.setItem('googleurl', node?.attributes?.field_link_url?.[0].uri || "");
    localStorage.setItem('googleimg', galleryUrls?.[1] || "");
    localStorage.setItem('grooneappcontent', node?.attributes?.field_sub_description?.[0] || "");
  return (

     <>
     
       <div className="gro-one-footer" style={divStyle} >
            <div className="container ">
                <div className="cta footer">
                    <label className="footer-h1">
                       {node?.attributes?.field_description}
                        <span> {node?.attributes?.field_title?.[0]}</span>
                    </label>
                    <h4>{node?.attributes?.field_title?.[1]}</h4>
                    <a href={node?.attributes?.field_link_url?.[1].uri} title={node?.attributes?.field_link_url?.[1].title}  ><img src={galleryUrls?.[0]} alt="App Store" className="img-fluid" /></a>
                    <a href={node?.attributes?.field_link_url?.[0].uri} title={node?.attributes?.field_link_url?.[0].title} className="mainfooter" ><img src={galleryUrls?.[1]} alt="Google Store" className="img-fluid" /></a>
                </div>
            </div>
         </div>
       
   </>
  );
};

export default FooterSubONew